export default "__VITE_ASSET__CB9emurg__"